export default {
  'menu.workbench': 'ようこそ',
  'menu.more-blocks': 'その他のブロック',
  'menu.home': 'ホーム',
  'menu.enterprise-overview': '企業概要',
  'menu.organization-structure': '組織構造',
  'menu.organization-structure.members-and-departments': 'メンバーと部門',
  'menu.organization-structure.role-management': 'ロール管理',
  'menu.cost-center': '費用センター',
  'menu.cost-center.my-subscription': 'マイサブスクリプション',
  'menu.cost-center.purchase-catalog': 'パッケージ購入',
  'menu.cost-center.entitlements-upgrade': 'アップグレード',
  'menu.cost-center.my-products': '私のプロダクト',
  'menu.cost-center.seat-allocation': '席の割り当て',
  'menu.cost-center.entitlements': '権益データ',
  'menu.cost-center.orders': '注文一覧',
  'menu.cost-center.invoices': '請求書管理',
  'menu.ai-usage': 'AI 利用管理',
  'menu.ai-usage.usage-overview': '利用概要',
  'menu.ai-usage.usage-details': '利用詳細',
  'menu.ai-usage.usage-logs': '利用ログ',
  'menu.ai-usage.quota-management': '上限管理',
  'menu.ai-usage.storage-space': 'ストレージスペース',
  'menu.ai-usage.storage-space.capacity-overview': '容量概要',
  'menu.ai-usage.storage-space.storage-cleanup': 'ストレージクリーンアップ',
  'menu.ai-usage.storage-space.limit-management': '上限管理',
  'menu.enterprise-culture': '企業文化',
  'menu.enterprise-culture.brand-config': 'ブランド設定',
  'menu.enterprise-settings': '企業設定',
  'menu.enterprise-settings.enterprise-info': '企業情報',
  'menu.enterprise-settings.admin-permissions': '管理者権限',
  'menu.bot-management': 'ボット管理',
  'menu.receive-management': 'メッセージ受信管理',
  'menu.receive-management.receive-config': '基本受信設定',
  'menu.receive-management.bot-config': 'ボット受信設定',
  'menu.receive-management.category-management': 'メッセージ分類管理',
  'menu.roles-and-permissions': 'ロールと権限',
  'menu.roles-and-permissions.permission-management': '権限管理',
  'menu.login': 'ログイン',
  'menu.dashboard': 'ダッシュボード',
  'menu.dashboard.analysis': '分析',
  'menu.dashboard.monitor': 'モニター',
  'menu.dashboard.workplace': '職場',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'フォーム',
  'menu.form.basic-form': '基本フォーム',
  'menu.form.step-form': 'ステップフォーム',
  'menu.form.step-form.info': 'ステップフォーム（転送情報の書き込み）',
  'menu.form.step-form.confirm': 'ステップフォーム（転送情報の確認）',
  'menu.form.step-form.result': 'ステップフォーム（完成）',
  'menu.form.advanced-form': '高度なフォーム',
  'menu.list': 'リスト',
  'menu.list.table-list': '検索テーブル',
  'menu.list.basic-list': '基本リスト',
  'menu.list.card-list': 'カードリスト',
  'menu.list.search-list': '検索リスト',
  'menu.list.search-list.articles': '検索リスト(記事)',
  'menu.list.search-list.projects': '検索リスト(プロジェクト)',
  'menu.list.search-list.applications': '検索リスト(アプリ)',
  'menu.profile': 'プロフィール',
  'menu.profile.basic': '基本プロフィール',
  'menu.profile.advanced': '高度なプロフィール',
  'menu.result': '結果',
  'menu.result.success': '成功',
  'menu.result.fail': '失敗',
  'menu.exception': '例外',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'トリガー',
  'menu.account': 'アカウント',
  'menu.account.center': 'アカウントセンター',
  'menu.account.workbench': 'ワークベンチに戻る',
  'menu.account.tenantManagement': 'テナント管理',
  'menu.account.trigger': 'トリガーエラー',
  'menu.account.logout': 'ログアウト',
  'menu.editor': 'グラフィックエディタ',
  'menu.editor.flow': 'フローエディタ',
  'menu.editor.mind': 'マインドエディター',
  'menu.editor.koni': 'コニエディター',
};
